export default __webpack_public_path__ + "static/media/loop-studios.7778c957.svg";